module.exports = __webpack_public_path__ + "static/media/19ESCAP19.02b93e1d.jpg";